import React, { useEffect, useState } from "react";
import {
  Heading,
  CommonInput,
  CommonButton,
  ButtonHeading,
  CustomSelect,
} from "components";
import { useDispatch, useSelector } from "react-redux";
import {
  addSingleCity,
  addSingleState,
  getCountries,
  getCountriesStates,
} from "../../features/locationService/locationActions";
import { errorSchema, utils } from "helper";
import toast from "react-hot-toast";
const stateObject = {
  countryCode: "",
  isoCode: "",
  name: "",
  latitude: "",
  longitude: "",
};

const cityObj = {
  countryCode: "",
  stateCode: "",
  name: "",
  latitude: "",
  longitude: "",
};

const Location = () => {
  const dispatch = useDispatch();
  const { countries, states, loading, error } = useSelector(
    (state) => state.location
  );
  const countriesData = countries?.data || [];
  const statesData = states?.data || [];
  const [formError, setFormError] = useState({});

  const [stateDetails, setStateDetails] = useState(stateObject);

  const [cityDetails, setCityDetails] = useState(cityObj);
  const [dropDownValues, setdropDownValues] = useState({
    stateCountry: null,
    cityCountry: null,
    cityState: null,
  });

  const [stateErrors, setStateErrors] = useState(stateObject);
  const [cityErrors, setCityErrors] = useState(cityObj);

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(countriesData) && countriesData.length > 0) {
      const defaultCountry = countriesData.find(
        (country) => country.isoCode === "IN"
      );
      if (defaultCountry) {
        const defaultValue = {
          label: `${defaultCountry.name} (${defaultCountry.isoCode})`,
          value: defaultCountry.isoCode,
        };
        setdropDownValues((prevValues) => ({
          ...prevValues,
          stateCountry: defaultValue,
          cityCountry: defaultValue,
        }));
        setStateDetails({
          ...stateDetails,
          countryCode: defaultCountry.isoCode,
        });
        setCityDetails({
          ...cityDetails,
          countryCode: defaultCountry.isoCode,
        });
      }
    }
  }, [countriesData]);

  useEffect(() => {
    if (cityDetails?.countryCode) {
      const payload = {
        countryCode: cityDetails?.countryCode,
        stateCode: "",
      };
      dispatch(getCountriesStates(payload));
    }
  }, [cityDetails?.countryCode]);

  const countyOption =
    Array.isArray(countriesData) && countriesData?.length > 0
      ? countriesData?.map((country) => ({
          label: `${country.name} (${country.isoCode})`,
          value: country.isoCode,
        }))
      : [];

  const stateOption =
    Array.isArray(statesData) && statesData?.length > 0
      ? statesData?.map((state) => ({
          label: `${state.name} (${state.isoCode})`,
          value: state.isoCode,
        }))
      : [];

  const handleInputChange1 = async (name, value) => {
    const stateObj = { ...stateDetails, [name]: value };
    setStateDetails(stateObj);

    // Validate only the updated field if stateErrors is not empty
    if (!utils.isObjectKeyEmpty(stateErrors)) {
      const validationResult = await utils.checkFormError(
        { [name]: value }, // Validate only the updated field
        { [name]: errorSchema.locationStateSchema[name] } // Schema for the updated field
      );

      // Merge new validation result with existing errors
      setStateErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationResult === true ? null : validationResult[name],
      }));
    }
  };

  const handleInputChange2 = async (name, value) => {
    const stateObj = { ...cityDetails, [name]: value };
    setCityDetails(stateObj);

    if (!utils.isObjectKeyEmpty(cityErrors)) {
      const validationResult = await utils.checkFormError(
        { [name]: value }, // Validate only the updated field
        { [name]: errorSchema.locationCitySchema[name] } // Schema for the updated field
      );

      //   if (validationResult === true) {
      //     setCityErrors(cityObj);
      //   } else {
      //     setCityErrors(validationResult);
      //   }
      setCityErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationResult === true ? null : validationResult[name],
      }));
    }
  };

  const handleSaveState = async () => {
    if (!utils.isObjectKeyEmpty(stateErrors)) {
      const validationResult = await utils.checkFormError(
        stateDetails,
        errorSchema.locationStateSchema
      );
      if (validationResult === true) {
        setStateErrors({});
        try {
          const response = await dispatch(addSingleState(stateDetails));
          if (response.payload?.data?.responseCode === 200) {
            setStateDetails(stateObject);
            toast.success(response.payload?.data?.responseMessage);
          }
        } catch (error) {
          console.error("Error saving state:", error);
        }
      } else {
        setStateErrors(validationResult);
      }
    }
  };

  const handleSaveCity = async () => {
    if (!utils.isObjectKeyEmpty(cityErrors)) {
      const validationResult = await utils.checkFormError(
        cityDetails,
        errorSchema.locationCitySchema
      );
      if (validationResult === true) {
        setCityErrors(cityObj);
        try {
          const response = await dispatch(addSingleCity(cityDetails));
          if (response.payload?.responseCode === 200) {
            setCityDetails(cityObj);
            toast.success(response.payload?.responseMessage);
          }
        } catch (error) {
          console.error("Error saving state:", error);
        }
      } else {
        setCityErrors(validationResult);
      }
    }
  };

  return (
    <React.Fragment>
      <ButtonHeading title="Location" />
      <div className="_vd_location">
        {/* State Form */}
        <div className="_vd_form-container">
          <h3>State</h3>

          <div className="_vd_form-group">
            <CustomSelect
              id="countryCode"
              name="countryCode"
              options={countyOption}
              placeholder="Select country"
              value={dropDownValues?.stateCountry || ""}
              onSelect={(selectedValue) => {
                handleInputChange1("countryCode", selectedValue.value);
                setdropDownValues({
                  ...dropDownValues,
                  stateCountry: selectedValue,
                });
              }}
              error={stateErrors?.countryCode || ""}
            />
          </div>
          <div className="_vd_form-group">
            <CommonInput
              label="State Name"
              type="text"
              id="name"
              name="name"
              placeholder="Enter state name"
              value={stateDetails.name}
              onChange={({ target: { name, value } }) =>
                handleInputChange1(name, value)
              }
              error={stateErrors?.name || ""}
            />
          </div>
          <div className="_vd_form-group">
            <CommonInput
              label="State Code"
              type="text"
              id="isoCode"
              name="isoCode"
              placeholder="Enter state code"
              value={stateDetails.isoCode}
              onChange={({ target: { name, value } }) =>
                handleInputChange1(name, value)
              }
              error={stateErrors?.isoCode || ""}
            />
          </div>
          <div className="_vd_form-group">
            <CommonInput
              label="Latitude"
              type="number"
              id="latitude"
              name="latitude"
              placeholder="Enter latitude"
              value={stateDetails.latitude}
              onChange={({ target: { name, value } }) =>
                handleInputChange1(name, value)
              }
              error={stateErrors?.latitude || ""}
            />
          </div>
          <div className="_vd_form-group">
            <CommonInput
              label="Longitude"
              type="number"
              id="longitude"
              name="longitude"
              placeholder="Enter longitude"
              value={stateDetails.longitude}
              onChange={({ target: { name, value } }) =>
                handleInputChange1(name, value)
              }
              error={stateErrors?.longitude || ""}
            />
          </div>
          <CommonButton
            buttonTitle={"Save State"}
            className="_submit_btn _addComm_btn anime-btn _vtype_btn"
            type="button"
            onClick={handleSaveState}
          />
        </div>

        {/* City Form */}
        <div className="_vd_form-container">
          <h3>City</h3>

          <div className="_vd_form-group">
            <CustomSelect
              id="countryCode"
              name="countryCode"
              options={countyOption}
              placeholder="Select country"
              value={dropDownValues?.cityCountry || ""}
              onSelect={(selectedValue) => {
                handleInputChange2("countryCode", selectedValue.value);
                setdropDownValues({
                  ...dropDownValues,
                  cityCountry: selectedValue,
                });
              }}
              error={cityErrors?.countryCode || ""}
            />
          </div>

          <div className="_vd_form-group">
            <CustomSelect
              id="stateCode"
              name="stateCode"
              options={stateOption}
              placeholder="Select State"
              value={dropDownValues?.cityState || ""}
              onSelect={(selectedValue) => {
                handleInputChange2("stateCode", selectedValue.value);
                setdropDownValues({
                  ...dropDownValues,
                  cityState: selectedValue,
                });
              }}
              error={cityErrors?.stateCode || ""}
            />
          </div>
          <div className="_vd_form-group">
            <CommonInput
              label="City Name"
              type="text"
              id="name"
              name="name"
              placeholder="Enter city name"
              value={cityDetails.name}
              onChange={({ target: { name, value } }) =>
                handleInputChange2(name, value)
              }
              error={cityErrors?.name || ""}
            />
          </div>
          <div className="_vd_form-group">
            <CommonInput
              label="Latitude"
              type="number"
              id="latitude"
              name="latitude"
              placeholder="Enter latitude"
              value={cityDetails.latitude}
              onChange={({ target: { name, value } }) =>
                handleInputChange2(name, value)
              }
              error={cityErrors?.latitude || ""}
            />
          </div>
          <div className="_vd_form-group">
            <CommonInput
              label="Longitude"
              type="number"
              id="longitude"
              name="longitude"
              placeholder="Enter longitude"
              value={cityDetails.longitude}
              onChange={({ target: { name, value } }) =>
                handleInputChange2(name, value)
              }
              error={cityErrors?.longitude || ""}
            />
          </div>

          <CommonButton
            buttonTitle={"Save City"}
            className="_submit_btn _addComm_btn anime-btn _vtype_btn"
            type="button"
            onClick={handleSaveCity}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Location;
